import { render, staticRenderFns } from "./ProfileManagerStaff.vue?vue&type=template&id=0bc130c8"
import script from "./ProfileManagerStaff.vue?vue&type=script&lang=js"
export * from "./ProfileManagerStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports